@import 'styles/antd-vars.less';

@pro-header-hover-bg: rgba(0, 0, 0, 0.025);

.menu {
  :global(.anticon) {
    margin-right: 8px;
  }
  :global(.ant-dropdown-menu-item) {
    min-width: 160px;
  }
}

.globalHeaderRight {
  width: 100%;
  min-width: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.right {
  display: flex;
  height: 48px;
  margin-left: auto;
  flex-shrink: 0;
  overflow: visible;
  .action {
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 12px;
    cursor: pointer;
    transition: all 0.3s;
    > span {
      vertical-align: middle;
    }
    &:hover {
      background: @pro-header-hover-bg;
    }
    &:global(.opened) {
      background: @pro-header-hover-bg;
    }
  }
  .search {
    padding: 0 12px;
    &:hover {
      background: transparent;
    }
  }
  .account {
    .avatar {
      margin-right: 8px;
      color: @primary-color;
      vertical-align: top;
      background: rgba(255, 255, 255, 0.85);
    }
  }
}

.dark {
  .action {
    &:hover {
      background: #252a3d;
    }
    &:global(.opened) {
      background: #252a3d;
    }
  }
}

// Icon-only header button (used for Manual, Dev, Support)
.iconButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  color: #8c8c8c;
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  
  &:hover {
    color: #1890ff;
    background: #f5f5f5;
    border-color: #d9d9d9;
  }
  
  :global(.anticon) {
    font-size: 18px;
  }
}

// Search Trigger - looks like an input but opens Command Palette
.searchTrigger {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 400px;
  max-width: 100%;
  flex-shrink: 1;
  min-width: 180px;
  height: 36px;
  padding: 0 12px 0 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #f4f5f7 100%);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fb 100%);
    border-color: #d1d5db;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  }

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
  }

  &:active {
    transform: scale(0.99);
  }
}

.searchTriggerIcon {
  color: #9ca3af;
  font-size: 14px;
  flex-shrink: 0;
}

.searchTriggerPlaceholder {
  flex: 1;
  color: #9ca3af;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.searchTriggerShortcut {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;

  kbd {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    background: linear-gradient(180deg, #ffffff 0%, #f4f5f7 100%);
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    color: #6b7280;
    font-family: -apple-system, BlinkMacSystemFont, 'SF Mono', 'Monaco', 'Inconsolata', 'Fira Code', 'Droid Sans Mono', monospace;
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
  }
}